<template>
    <div class="pt-4" style="padding-left: 10px;" >
        <span :class="{'textGroupHeader': true, 'today': isToday}">{{ formattedGroupTile }}</span>
    </div>
</template>

<script>
export default {
  props:["groupTile"],
  computed: {
    formattedGroupTile() {
      const parts = this.groupTile.split('-');
      return `${parts[0]}/${parts[1]}/${parts[2]}`;
    },
    isToday() {
      const formattedToday = new Date().toLocaleDateString('vi-VN');
      const formattedGroupTile = new Date(this.groupTile).toLocaleDateString('vi-VN');
      return formattedGroupTile === formattedToday;
    }
  }
}
</script>

<style scoped>
.textGroupHeader {
  font-weight: bold;
  padding-top: 8px;
  font-size: 1.25em;
}
.today {
  color: #1F97FE;
}

@media only screen and (max-width: 767px) {
  .v-application .pt-4 {
    margin-top: -12px !important;
}
}
</style>